import BaseChartCard from 'common/components/BaseChartCard'
import { useGetGrowthShrimpLineChart, useGetGrowthShrimpToday } from 'modules/growth/api/queries'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

import GrowthShrimpDialog from '../GrowthShrimpDialog'
import GrowthShrimpLineChart from '../GrowthShrimpLineChart'
import { usePermitByFeature, usePermitToActionFeature } from 'modules/user/api/selector'
import { CRUDAction, FeatureKey } from 'common/constants/permission'
import GrowthCardContent from '../GrowthCardContent'
import { useSpeciesName } from 'modules/pond/api/selector'
import { fNumber } from 'common/utils/formatNumber'

interface GrowthShrimpChartProps {
  hideButton?: boolean
}

const GrowthShrimpChart = ({ hideButton }: GrowthShrimpChartProps) => {
  const { t } = useTranslation('growth')
  const { refetch } = useGetGrowthShrimpLineChart()
  const speciesName = useSpeciesName();
  const {
    data,
  } = useGetGrowthShrimpToday();

  const sizeValue = data?.pages[0].shrimpCountPerKg;

  return (
    <BaseChartCard title={t('growth')} refresh={refetch}>
      <GrowthCardContent
        pdg={fNumber(data?.pages[0].PDG ?? 0)}
        adg={fNumber(data?.pages[0].ADG ?? 0)}
        shrimpSizeText= {`${sizeValue ?? '-'}${speciesName === 'กุ้ง' ? ' ตัว/กก.' : ' กรัม/ตัว'}`}
        refetch={refetch}
      />
    </BaseChartCard>
  )
}

export default GrowthShrimpChart
